import { useState, useEffect, useRef } from "react";
import { db, storage } from "../../services/firebaseConnection";
import { useNavigate } from "react-router-dom";
import InputControlado from "../../components/InputControlado";
import { useAuth } from "../../context/AuthContext";

import {
  collection,
  addDoc,
  query,
  getDocs,
  orderBy,
  where,
  doc,
  getDoc,
} from "firebase/firestore";

import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import home from "../../assets/icons/bookfuncionario/turn.png";
import "./cadastro.css";

const Cadastro = () => {
  const navigate = useNavigate();
  const { usuarioLogado } = useAuth();

  const [searchInput, setSearchInput] = useState("");
  const [arquivoAnexo, setArquivoAnexo] = useState(null);
  const [enviandoArquivo, setEnviandoArquivo] = useState(false);

  const [selectedEmployee, setSelectedEmployee] = useState({
    id: "",
    name: "FUNCIONÁRIO",
    role: "FUNÇÃO",
    cpf: "CPF",
    project: "OBRA",
    situation: "",
    matrizesAplicadas: [],
  });

  const [trainingData, setTrainingData] = useState({
    name: "",
    date: "",
    evaluator: "",
    registeredBy: "",
    possuiVencimento: true,
    validadeMesesCatalogo: "",
    tipo: "",
  });

  const [suggestions, setSuggestions] = useState([]);
  const [trainingsList, setTrainingsList] = useState([]);
  const [treinamentosJaLancados, setTreinamentosJaLancados] = useState([]);

  const [showSuggestions, setShowSuggestions] = useState(false);

  const [showTrainingsDropdown, setShowTrainingsDropdown] = useState(false);

  const [allEmployees, setAllEmployees] = useState([]);

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const suggestionsRef = useRef(null);
  const trainingsDropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const inputArquivoRef = useRef(null);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const querySnapshot = await getDocs(
          query(collection(db, "funcionarios"), orderBy("nome")),
        );

        const employees = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
            searchName: normalizeText(doc.data().nome || ""),
            cleanCpf: cleanCPF(doc.data().cpf || ""),
          }))
          .filter((employee) => employee.situacao === "ATIVO");

        setAllEmployees(employees);
        setIsInitialLoad(false);
      } catch (error) {
        console.error("Erro ao buscar funcionários:", error);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    if (usuarioLogado?.nome) {
      setTrainingData((prev) => ({
        ...prev,
        registeredBy: usuarioLogado.nome,
      }));
    }
  }, [usuarioLogado]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }

      if (
        trainingsDropdownRef.current &&
        !trainingsDropdownRef.current.contains(event.target)
      ) {
        setShowTrainingsDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    searchInputRef.current?.focus();
  }, []);

  const normalizeText = (str) => {
    return str
      ? str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase()
          .trim()
      : "";
  };

  const cleanCPF = (cpf) => cpf?.replace(/\D/g, "") || "";

  const formatCPF = (cpf) => {
    const numbers = cpf.replace(/\D/g, "");

    return numbers.length === 11
      ? numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
      : "CPF";
  };

  const limparNomeArquivo = (valor = "") => {
    return valor
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w.-]/g, "_")
      .toUpperCase();
  };

  const validarArquivoPDF = (arquivo) => {
    if (!arquivo) return false;

    return (
      arquivo.type === "application/pdf" ||
      arquivo.name.toLowerCase().endsWith(".pdf")
    );
  };

  const validarDataTreinamento = (data) => {
    if (!data) return false;

    const partes = data.split("-");

    if (partes.length !== 3) return false;

    const [ano, mes, dia] = partes;

    if (!/^\d{4}$/.test(ano)) return false;
    if (ano.startsWith("0")) return false;
    if (!/^\d{2}$/.test(mes)) return false;
    if (!/^\d{2}$/.test(dia)) return false;

    const anoNumero = Number(ano);
    const mesNumero = Number(mes);
    const diaNumero = Number(dia);

    if (anoNumero < 1900 || anoNumero > 2100) return false;
    if (mesNumero < 1 || mesNumero > 12) return false;
    if (diaNumero < 1 || diaNumero > 31) return false;

    const dataObj = new Date(anoNumero, mesNumero - 1, diaNumero);

    return (
      dataObj.getFullYear() === anoNumero &&
      dataObj.getMonth() === mesNumero - 1 &&
      dataObj.getDate() === diaNumero
    );
  };

  const handleDateChange = (e) => {
    setTrainingData((prev) => ({
      ...prev,
      date: e.target.value,
    }));
  };

  const handleDateBlur = () => {
    if (!trainingData.date) return;

    if (!validarDataTreinamento(trainingData.date)) {
      alert(
        "Data inválida. O ano deve ter 4 dígitos, não pode começar com 0 e precisa ser uma data real.",
      );

      setTrainingData((prev) => ({
        ...prev,
        date: "",
      }));
    }
  };

  const searchEmployees = (searchTerm) => {
    const normalizedTerm = normalizeText(searchTerm);

    const cpfOnly = cleanCPF(searchTerm);

    if (!normalizedTerm && !cpfOnly) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    const results = allEmployees.filter((emp) => {
      const startsWithName = emp.searchName.startsWith(normalizedTerm);

      const exactCpfMatch = emp.cleanCpf === cpfOnly;

      return startsWithName || (cpfOnly.length === 11 && exactCpfMatch);
    });

    setSuggestions(results.slice(0, 5));
    setShowSuggestions(results.length > 0);
  };

  const buscarMatrizesDaObra = async (obraNome) => {
    try {
      const obraRef = doc(db, "obras_atuais", obraNome);

      const obraSnap = await getDoc(obraRef);

      if (!obraSnap.exists()) {
        return [];
      }

      const dadosObra = obraSnap.data();

      return dadosObra.matrizesAplicadas || [];
    } catch (error) {
      console.error("Erro ao buscar matrizes da obra:", error);
      return [];
    }
  };

  const buscarTreinamentosJaLancados = async (employeeId) => {
    try {
      if (!employeeId) {
        setTreinamentosJaLancados([]);
        return [];
      }

      const treinamentosRef = collection(
        db,
        "funcionarios",
        employeeId,
        "treinamentos",
      );

      const snapshot = await getDocs(treinamentosRef);

      const lista = snapshot.docs
        .map((docItem) => {
          const dados = docItem.data();
          return normalizeText(dados.treinamentoNome || dados.tipo || "");
        })
        .filter(Boolean);

      setTreinamentosJaLancados(lista);
      return lista;
    } catch (error) {
      console.error("Erro ao buscar treinamentos já lançados:", error);
      setTreinamentosJaLancados([]);
      return [];
    }
  };

  const treinamentoJaLancado = (nomeTreinamento = "") => {
    const nomeNormalizado = normalizeText(nomeTreinamento);

    if (!nomeNormalizado) return false;

    return treinamentosJaLancados.includes(nomeNormalizado);
  };

  const handleEmployeeSelect = async (employee) => {
    setSearchInput(employee.nome);
    setTrainingData((prev) => ({
      ...prev,
      name: "",
      possuiVencimento: true,
      validadeMesesCatalogo: "",
      tipo: "",
    }));
    setTrainingsList([]);
    setShowTrainingsDropdown(false);

    const matrizesAplicadas = await buscarMatrizesDaObra(employee.obra);
    await buscarTreinamentosJaLancados(employee.id);

    setSelectedEmployee({
      id: employee.id,
      name: employee.nome,
      role: employee.funcao || "FUNÇÃO",
      cpf: formatCPF(employee.cpf),
      project: employee.obra || "OBRA",
      situation: employee.situacao || "",
      matrizesAplicadas,
    });

    setShowSuggestions(false);
  };

  const searchTrainings = async (term = "") => {
    try {
      if (
        !selectedEmployee.project ||
        !selectedEmployee.matrizesAplicadas ||
        !selectedEmployee.role
      ) {
        setTrainingsList([]);
        return;
      }

      let treinamentosAgrupados = [];

      for (const matriz of selectedEmployee.matrizesAplicadas) {
        const treinamentosRef = collection(
          db,
          "matrizes",
          matriz,
          "funcoes",
          selectedEmployee.role,
          "treinamentos",
        );

        const querySnapshot = await getDocs(treinamentosRef);

        const treinamentos = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          matrizOrigem: matriz,
          normalizedName: normalizeText(doc.data().nome || ""),
        }));

        treinamentosAgrupados.push(...treinamentos);
      }

      const mapaTreinamentos = new Map();

      treinamentosAgrupados.forEach((treinamento) => {
        const chave = normalizeText(treinamento.nome);

        if (!mapaTreinamentos.has(chave)) {
          mapaTreinamentos.set(chave, treinamento);
        }
      });

      const treinamentosUnicos = Array.from(mapaTreinamentos.values());

      const normalizedTerm = normalizeText(term);

      const results = term
        ? treinamentosUnicos.filter((t) =>
            t.normalizedName.includes(normalizedTerm),
          )
        : treinamentosUnicos;

      const resultsComStatus = results.map((treinamento) => ({
        ...treinamento,
        jaLancado: treinamentoJaLancado(treinamento.nome),
      }));

      setTrainingsList(resultsComStatus);

      setShowTrainingsDropdown(true);
    } catch (error) {
      console.error("Erro ao buscar treinamentos:", error);

      setTrainingsList([]);
    }
  };

  const handleTrainingSelect = (training) => {
    if (training.jaLancado || treinamentoJaLancado(training.nome)) {
      alert("Este treinamento já foi lançado para este colaborador.");
      return;
    }

    setTrainingData((prev) => ({
      ...prev,
      name: training.nome || "",
      possuiVencimento: training.validade ? true : false,
      validadeMesesCatalogo: training.validade || "",
      tipo: training.tipo || "",
    }));

    setShowTrainingsDropdown(false);
  };

  const handleArquivoChange = (e) => {
    const arquivo = e.target.files?.[0];

    if (!arquivo) {
      setArquivoAnexo(null);
      return;
    }

    if (!validarArquivoPDF(arquivo)) {
      alert("Só é permitido anexar arquivos em PDF.");

      setArquivoAnexo(null);

      if (inputArquivoRef.current) {
        inputArquivoRef.current.value = "";
      }

      return;
    }

    setArquivoAnexo(arquivo);
  };

  const removerArquivo = () => {
    setArquivoAnexo(null);

    if (inputArquivoRef.current) {
      inputArquivoRef.current.value = "";
    }
  };

  const criarAuditoria = async ({ acao, entidade, entidadeId, detalhes }) => {
    try {
      await addDoc(collection(db, "auditoria_sistema"), {
        acao,
        entidade,
        entidadeId,
        detalhes,

        responsavelNome: usuarioLogado?.nome || "",
        responsavelId: usuarioLogado?.id || "",

        dataHora: new Date().toISOString(),
      });
    } catch (error) {
      console.error("Erro ao criar auditoria:", error);
    }
  };

  const registerTraining = async () => {
    const cpfNumbers = cleanCPF(selectedEmployee.cpf);

    if (cpfNumbers.length !== 11 || !selectedEmployee.id) {
      alert("Selecione um funcionário válido!");
      return;
    }

    if (selectedEmployee.situation !== "ATIVO") {
      alert(
        "Não é possível cadastrar treinamento para funcionário desativado!",
      );

      return;
    }

    if (
      !trainingData.name ||
      !trainingData.date ||
      !trainingData.evaluator ||
      !trainingData.registeredBy
    ) {
      alert("Preencha todos os campos do treinamento!");
      return;
    }

    if (treinamentoJaLancado(trainingData.name)) {
      alert("Este treinamento já está cadastrado para este funcionário!");
      return;
    }

    if (!validarDataTreinamento(trainingData.date)) {
      alert(
        "A data do treinamento é inválida. Use um ano com 4 dígitos e que não comece com 0.",
      );

      return;
    }

    if (!arquivoAnexo) {
      alert("Anexe o arquivo PDF do treinamento antes de cadastrar.");
      return;
    }

    if (!validarArquivoPDF(arquivoAnexo)) {
      alert("Só é permitido cadastrar arquivo em PDF.");
      return;
    }

    try {
      setEnviandoArquivo(true);

      const trainingRef = collection(
        db,
        "funcionarios",
        cpfNumbers,
        "treinamentos",
      );

      const checkQuery = query(
        trainingRef,
        where("treinamentoNome", "==", trainingData.name),
      );

      const checkSnapshot = await getDocs(checkQuery);

      if (!checkSnapshot.empty) {
        alert("Este treinamento já está cadastrado para este funcionário!");

        return;
      }

      const nomeTreinamentoLimpo = limparNomeArquivo(trainingData.name);

      const nomeArquivoLimpo = limparNomeArquivo(arquivoAnexo.name);

      const obraLimpa = limparNomeArquivo(selectedEmployee.project);

      const funcaoLimpa = limparNomeArquivo(selectedEmployee.role);

      const dataArquivo = Date.now();

      const caminhoArquivo = `treinamentos/${cpfNumbers}/${obraLimpa}/${funcaoLimpa}/${nomeTreinamentoLimpo}/${dataArquivo}_${nomeArquivoLimpo}`;

      const arquivoRef = ref(storage, caminhoArquivo);

      await uploadBytes(arquivoRef, arquivoAnexo);

      const arquivoUrl = await getDownloadURL(arquivoRef);

      const treinamentoSalvo = {
        tipo: trainingData.tipo || "",

        treinamentoNome: trainingData.name,

        data: trainingData.date,

        avaliador: trainingData.evaluator,

        colaboradorNome: selectedEmployee.name,
        colaboradorCpf: cpfNumbers,
        colaboradorId: selectedEmployee.id,

        obraNaData: selectedEmployee.project,
        funcaoNaData: selectedEmployee.role,

        matrizesNaData: selectedEmployee.matrizesAplicadas || [],

        cadastradoPor: trainingData.registeredBy,

        cadastradoPorId: usuarioLogado?.id || "",

        validadeMeses: trainingData.validadeMesesCatalogo || "",

        possuiVencimento: trainingData.possuiVencimento,

        anexoNome: arquivoAnexo.name,
        anexoUrl: arquivoUrl,
        anexoPath: caminhoArquivo,

        anexoTipo: "application/pdf",

        anexoTamanho: arquivoAnexo.size || 0,

        dataCadastro: new Date().toISOString(),
      };

      const docRef = await addDoc(trainingRef, treinamentoSalvo);

      setTreinamentosJaLancados((prev) => [
        ...prev,
        normalizeText(trainingData.name),
      ]);

      await criarAuditoria({
        acao: "CADASTRO_TREINAMENTO",

        entidade: "TREINAMENTO",

        entidadeId: docRef.id,

        detalhes: {
          treinamento: trainingData.name,

          colaborador: selectedEmployee.name,

          cpf: cpfNumbers,

          obra: selectedEmployee.project,

          funcao: selectedEmployee.role,
        },
      });

      alert("Treinamento cadastrado com sucesso!");

      setTrainingData({
        name: "",
        date: "",
        evaluator: "",
        registeredBy: usuarioLogado?.nome || "",
        possuiVencimento: true,
        validadeMesesCatalogo: "",
        tipo: "",
      });

      setArquivoAnexo(null);

      if (inputArquivoRef.current) {
        inputArquivoRef.current.value = "";
      }
    } catch (error) {
      console.error("Erro ao cadastrar:", error);

      alert("Erro ao cadastrar treinamento");
    } finally {
      setEnviandoArquivo(false);
    }
  };

  return (
    <div className="container-cadastro">
      <div className="container-info">
        <div className="container-add">
          <div className="search" ref={suggestionsRef}>
            <InputControlado
              ref={searchInputRef}
              type="text"
              placeholder="DIGITE CPF OU NOME"
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value.toUpperCase());

                searchEmployees(e.target.value);
              }}
              onFocus={() => {
                if (!isInitialLoad && searchInput) {
                  searchEmployees(searchInput);
                }
              }}
              onKeyDown={(e) =>
                e.key === "Enter" && searchEmployees(searchInput)
              }
            />

            {showSuggestions && (
              <div className="dropdown-funcionario">
                {suggestions.map((emp) => (
                  <div
                    key={emp.id}
                    className="dropdown-item"
                    onClick={() => handleEmployeeSelect(emp)}
                  >
                    {emp.nome} — {formatCPF(emp.cpf)}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="dados-cadastro">
            <div className="dados-primarios">
              <p>{selectedEmployee.name}</p>

              <p>{selectedEmployee.project}</p>
            </div>

            <div className="dados-secundarios">
              <p>{selectedEmployee.role}</p>

              <p>{selectedEmployee.cpf}</p>
            </div>
          </div>

          <div className="dados">
            <div
              className="search-treinamento-cadastro"
              ref={trainingsDropdownRef}
            >
              <InputControlado
                type="text"
                placeholder="TREINAMENTOS"
                value={trainingData.name.toUpperCase()}
                onChange={(e) => {
                  setTrainingData((prev) => ({
                    ...prev,
                    name: e.target.value,
                    possuiVencimento: true,
                    validadeMesesCatalogo: "",
                    tipo: "",
                  }));

                  searchTrainings(e.target.value);
                }}
                onFocus={() => searchTrainings(trainingData.name)}
              />

              {showTrainingsDropdown && (
                <div className="dropdown-treinamentos">
                  {trainingsList.map((training) => (
                    <div
                      key={training.id}
                      className={
                        training.jaLancado
                          ? "dropdown-item treinamento-ja-lancado"
                          : "dropdown-item"
                      }
                      onClick={() => handleTrainingSelect(training)}
                      title={
                        training.jaLancado
                          ? "ESTE TREINAMENTO JÁ FOI LANÇADO PARA ESTE COLABORADOR"
                          : ""
                      }
                    >
                      <span>{training.nome}</span>

                      {training.jaLancado && <small>JÁ LANÇADO</small>}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <InputControlado
              type="date"
              value={trainingData.date}
              onChange={handleDateChange}
              onBlur={handleDateBlur}
            />

            <InputControlado
              type="text"
              placeholder="INSTRUTOR DO TREINAMENTO"
              value={trainingData.evaluator}
              onChange={(e) =>
                setTrainingData((prev) => ({
                  ...prev,
                  evaluator: e.target.value.toUpperCase(),
                }))
              }
            />

            <div className="campo-anexo-treinamento">
              <span className="label-anexo-treinamento">
                ANEXO DO TREINAMENTO
              </span>

              <input
                ref={inputArquivoRef}
                type="file"
                accept="application/pdf,.pdf"
                onChange={handleArquivoChange}
              />

              {arquivoAnexo && (
                <div className="arquivo-selecionado-cadastro">
                  <p>{arquivoAnexo.name}</p>

                  <button type="button" onClick={removerArquivo}>
                    REMOVER
                  </button>
                </div>
              )}
            </div>

            <div className="campo-usuario-logado">
              <span className="label-usuario-logado">USUÁRIO LOGADO</span>

              <InputControlado
                type="text"
                value={trainingData.registeredBy}
                readOnly
              />
            </div>
          </div>

          <div className="footer">
            <img
              className="icon-home-cadastro"
              onClick={() => navigate("/main")}
              src={home}
              alt="Voltar"
            />

            <div className="add-treinamento">
              <button onClick={registerTraining} disabled={enviandoArquivo}>
                {enviandoArquivo ? "ENVIANDO..." : "+ TREINAMENTO"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cadastro;
